import { List } from 'antd'
import { ListItemMetaProps } from 'antd/lib/list'
import { classNames } from 'app/lib'
import { ReactNode } from 'react'
import * as React from 'react'

interface Props extends ListItemMetaProps {
  extra?: ReactNode
  onClick?: () => void
  verticalAlign?: boolean
}

const KListItem: React.FC<Props> = ({
  title,
  avatar,
  description,
  extra,
  onClick,
  verticalAlign,
  className,
  ...others
}) => {
  return (
    <List.Item
      className={classNames(onClick && 'pointer', verticalAlign && 'd-flex v-align', className)}
      extra={extra}
      onClick={() => onClick?.()}
      {...others}>
      <List.Item.Meta avatar={avatar} title={title} description={description} />
    </List.Item>
  )
}

export default KListItem
